import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SimpleBotIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const LegacyAutomatedMessageAvatar = () => {
  return /*#__PURE__*/_jsx(IconCircle, {
    icon: SimpleBotIcon,
    color: 'icon-core-subtle',
    backgroundColor: 'fill-primary-disabled',
    borderWidth: "0",
    size: "600",
    padding: "25"
  });
};
LegacyAutomatedMessageAvatar.displayName = 'LegacyAutomatedMessageAvatar';
export default LegacyAutomatedMessageAvatar;